export const CHART_COLORS = {
    primary: {
        filipino: {
            main: '#4B5563',
            light: '#6B7280',
            dark: '#374151',
            bg: 'rgba(75, 85, 99, 0.1)',
            darkMode: {
                main: '#9CA3AF',
                light: '#D1D5DB',
                dark: '#6B7280',
                bg: 'rgba(156, 163, 175, 0.15)'
            }
        },
        english: {
            main: '#6366F1',
            light: '#818CF8',
            dark: '#4F46E5',
            bg: 'rgba(99, 102, 241, 0.1)',
            darkMode: {
                main: '#A5B4FC',
                light: '#C7D2FE',
                dark: '#818CF8',
                bg: 'rgba(165, 180, 252, 0.15)'
            }
        }
    },
    sentiment: {
        positive: {
            main: '#059669',
            light: '#10B981',
            dark: '#047857',
            bg: 'rgba(5, 150, 105, 0.1)',
            darkMode: {
                main: '#34D399',
                light: '#6EE7B7',
                dark: '#10B981',
                bg: 'rgba(52, 211, 153, 0.15)'
            }
        },
        neutral: {
            main: '#9CA3AF',
            light: '#D1D5DB',
            dark: '#6B7280',
            bg: 'rgba(156, 163, 175, 0.1)',
            darkMode: {
                main: '#D1D5DB',
                light: '#E5E7EB',
                dark: '#9CA3AF',
                bg: 'rgba(209, 213, 219, 0.15)'
            }
        },
        negative: {
            main: '#DC2626',
            light: '#EF4444',
            dark: '#B91C1C',
            bg: 'rgba(220, 38, 38, 0.1)',
            darkMode: {
                main: '#F87171',
                light: '#FCA5A5',
                dark: '#EF4444',
                bg: 'rgba(248, 113, 113, 0.15)'
            }
        }
    },
    detection: {
        automated: {
            main: '#0E7490',
            light: '#14B8A6',
            dark: '#0F766E',
            bg: 'rgba(14, 116, 144, 0.1)'
        },
        manual: {
            main: '#B45309',
            light: '#D97706',
            dark: '#92400E',
            bg: 'rgba(180, 83, 9, 0.1)'
        }
    },
    neutral: {
        background: {
            light: '#FFFFFF',
            dark: '#111111'
        },
        border: {
            light: 'rgba(0, 0, 0, 0.1)',
            dark: 'rgba(255, 255, 255, 0.1)'
        },
        text: {
            light: {
                primary: 'rgba(0, 0, 0, 0.9)',
                secondary: 'rgba(0, 0, 0, 0.6)'
            },
            dark: {
                primary: 'rgba(255, 255, 255, 0.9)',
                secondary: 'rgba(255, 255, 255, 0.6)'
            }
        }
    },
    monochrome: {
        white: {
            100: 'rgba(255, 255, 255, 1)',
            80: 'rgba(255, 255, 255, 0.8)',
            60: 'rgba(255, 255, 255, 0.6)',
            40: 'rgba(255, 255, 255, 0.4)',
            20: 'rgba(255, 255, 255, 0.2)',
            10: 'rgba(255, 255, 255, 0.1)',
            5: 'rgba(255, 255, 255, 0.05)'
        },
        black: {
            100: 'rgba(0, 0, 0, 1)',
            80: 'rgba(0, 0, 0, 0.8)',
            60: 'rgba(0, 0, 0, 0.6)',
            40: 'rgba(0, 0, 0, 0.4)',
            20: 'rgba(0, 0, 0, 0.2)',
            10: 'rgba(0, 0, 0, 0.1)',
            5: 'rgba(0, 0, 0, 0.05)'
        },
        gray: {
            50: '#F9FAFB',
            100: '#F3F4F6',
            200: '#E5E7EB',
            300: '#D1D5DB',
            400: '#9CA3AF',
            500: '#6B7280',
            600: '#4B5563',
            700: '#374151',
            800: '#1F2937',
            900: '#111827'
        }
    }
}; 